import { inject, type InjectionKey } from "vue";

import type { GridContext } from "@/v2/framework/grid/types";

export type { GridContext };

export const VIEW_CONTEXT_KEY: InjectionKey<GridContext> = Symbol("viewContext");

/** Optional parent grid when a dialog is hosted inside `DialogHost` (setup-time inject only). */
export const injectGridContext = (): GridContext | null => inject(VIEW_CONTEXT_KEY, null);
